// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create_custom_summery {
  position: relative;
}
.create_custom_summery .summery_card {
  margin-bottom: 20px;
}
.create_custom_summery .summery_card .card-header,
.create_custom_summery .summery_card .card-footer {
  background: #E5E5E5;
  border-top: 0;
  border-bottom: 0;
}
.create_custom_summery .summery_card .card-header i,
.create_custom_summery .summery_card .card-footer i {
  color: hsla(0, 0%, 0%, 0.124);
}
.create_custom_summery .summery_card .branch_sections {
  position: relative;
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem;
  background: hsla(0, 0%, 0%, 0.051);
  height: 100%;
}
.create_custom_summery .summery_card .branch_sections .title {
  position: absolute;
  font-weight: 600;
  line-height: 25px;
  color: #1B2430;
  transform: rotate(-90deg);
  width: 160px;
  left: -65px;
  top: 80px;
}
@media only screen and (max-width: 1199px) {
  .create_custom_summery .summery_card .branch_sections .title {
    left: -50px;
  }
}
@media (max-width: 991px) {
  .create_custom_summery .summery_card .branch_sections .title {
    left: -62px;
  }
}
@media (max-width: 767px) {
  .create_custom_summery .summery_card .branch_sections .title {
    left: -62px;
  }
}
@media (max-width: 578px) {
  .create_custom_summery .summery_card .branch_sections .title {
    left: -60px;
  }
}
.create_custom_summery .summery_card .content ul li {
  color: #787878;
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/questioners/create_question_paper/create_custom_questions/_createcustomsummery.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,mBAAA;AACR;AACQ;;EAEI,mBAAA;EACA,aAAA;EACA,gBAAA;AACZ;AACY;;EACI,6BAAA;AAEhB;AAEQ;EACI,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AAAZ;AAEY;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAAhB;AAEgB;EACI;IACI,WAAA;EAAtB;AACF;AAEgB;EACI;IACI,WAAA;EAAtB;AACF;AAGgB;EACI;IACI,WAAA;EADtB;AACF;AAGgB;EACI;IACI,WAAA;EADtB;AACF;AAMQ;EACI,cAAA;AAJZ","sourcesContent":[".create_custom_summery {\n    position: relative;\n\n    .summery_card {\n        margin-bottom: 20px;\n\n        .card-header,\n        .card-footer {\n            background: #E5E5E5;\n            border-top: 0;\n            border-bottom: 0;\n\n            i {\n                color: hsla(0, 0%, 0%, 0.124);\n            }\n        }\n\n        .branch_sections {\n            position: relative;\n            text-align: center;\n            vertical-align: middle;\n            padding: 0.5rem;\n            background: hsla(0, 0%, 0%, 0.051);\n            height: 100%;\n\n            .title {\n                position: absolute;\n                font-weight: 600;\n                line-height: 25px;\n                color: #1B2430;\n                transform: rotate(-90deg);\n                width: 160px;\n                left: -65px;\n                top: 80px;\n\n                @media only screen and (max-width: 1199px) {\n                    & {\n                        left: -50px;\n                    }\n                }\n                @media (max-width: 991px) {\n                    & {\n                        left: -62px;\n                    }\n                }\n\n                @media (max-width: 767px) {\n                    & {\n                        left: -62px;\n                    }\n                }\n                @media (max-width: 578px) {\n                    & {\n                        left: -60px;\n                    }\n                }\n            }\n        }\n\n        .content ul li {\n            color: #787878;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
